import React from 'react';
import { Button, useModalContext } from '@fourthwall/components';
import { PencilIcon, PlusIcon, TrashIcon } from '@fourthwall/icons';
import { EditSectionsModal } from '../EditSectionsModal/EditSectionsModal';
import * as S from './SectionsTab.styled';
import { useCreatePlatformAppSection } from './hooks/useCreatePlatformAppSection';
import { useDeletePlatformAppSection } from './hooks/useDeletePlatformAppSection';
import { useUpdatePlatformAppSection } from './hooks/useUpdatePlatformAppSection';
export const SectionsTab = ({ app }) => {
    const { open } = useModalContext();
    const { createPlatformAppSection, isLoading: isCreatingSection } = useCreatePlatformAppSection();
    const { updatePlatformAppSection, isLoading: isUpdatingSection } = useUpdatePlatformAppSection();
    const { deletePlatformAppSection, isLoading: isDeletingSection } = useDeletePlatformAppSection();
    const isLoading = isCreatingSection || isUpdatingSection || isDeletingSection;
    const handleAddSection = (section) => {
        open(EditSectionsModal, {
            title: 'Add Section',
            section,
            hmac: app.hmacKey,
            onSave: (newSection) => {
                createPlatformAppSection([{ appId: app.id }, newSection]);
            },
        });
    };
    const handleEditSection = (section) => {
        open(EditSectionsModal, {
            title: 'Edit Section',
            section,
            hmac: app.hmacKey,
            onSave: (updatedSection) => {
                updatePlatformAppSection([{ appId: app.id, sectionId: section.id }, updatedSection]);
            },
        });
    };
    const handleDeleteSection = (section) => {
        deletePlatformAppSection([{ appId: app.id, sectionId: section.id }]);
    };
    const renderSettingsInfo = (section) => {
        if (!section.settings || section.settings.length === 0) {
            return React.createElement(S.SectionSettingsInfo, null, "No settings configured");
        }
        return (React.createElement(S.SectionSettingsInfo, null,
            section.settings.length,
            " setting",
            section.settings.length !== 1 ? 's' : '',
            " configured"));
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Description, null, "App sections allow you to add custom pages and functionality to your app. Each section can be embedded as an iframe within your app and can have customizable settings."),
        app.sections.length > 0 ? (React.createElement(S.SectionsList, null, app.sections.map((section) => (React.createElement(S.SectionCard, { key: section.id },
            React.createElement(S.SectionInfo, null,
                React.createElement(S.SectionName, null, section.name),
                section.description && (React.createElement(S.SectionDescription, null, section.description)),
                React.createElement(S.SectionUrl, null, section.iframeUrl),
                renderSettingsInfo(section)),
            React.createElement(S.SectionActions, null,
                React.createElement(Button, { label: "Edit", appearance: "secondary", size: "small", leftIcon: React.createElement(PencilIcon, { height: 12 }), onClick: () => handleEditSection(section) }),
                React.createElement(Button, { label: "Delete", appearance: "secondary", size: "small", leftIcon: React.createElement(TrashIcon, { height: 12 }), onClick: () => handleDeleteSection(section) }))))))) : (React.createElement(S.PlaceholderContainer, null,
            React.createElement(S.PlaceholderText, null, "No sections added yet"),
            React.createElement(S.PlaceholderSubtext, null, "Add custom pages and functionality to your app by creating sections."))),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Add Section", appearance: "primary", leftIcon: React.createElement(PlusIcon, null), onClick: () => handleAddSection({
                    id: '',
                    name: '',
                    description: '',
                    iframeUrl: '',
                    settings: [],
                }), disabled: isLoading }))));
};
